import { Injectable } from "@angular/core";
import { BARRACKS } from "app/helpers/Constants";
import { HelperService } from "app/helpers/helper.service";
import { PostService } from "app/helpers/post.service";
import { BehaviorSubject, Observable } from "rxjs";
import { distinctUntilChanged } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class ConsByStateService {
  private _data: any = new BehaviorSubject(null);

  constructor(
    private postService: PostService,
    private helper: HelperService
  ) {}

  fetchConstituencyList = (parameters: any): Observable<any> => {
    const formData = new FormData();
    var storeCallback: any;

    storeCallback = (value) => {
      this._data.next(value);
    };
    formData.append("API_getConstituencyByCountry", "1");
    formData.append("countryId", parameters.country_id);
    formData.append("with_party_posts", "1");
    formData.append("barrackId", parameters.barrack_id);
    formData.append("barrack_index", BARRACKS[parameters.barrack_id]);

    let observable = this.postService.post(this.helper.getAPIUrl(), formData);
    observable.subscribe((val) => {
      storeCallback(val);
    });

    return this._data.pipe(
      distinctUntilChanged(
        (prev: any, curr: any) => JSON.stringify(prev) == JSON.stringify(curr)
      )
    );
  };
}
